<script setup lang="ts">
import { ref } from 'vue'

import TradingMonthAmount from './TradingMonthAmount.vue'
import TradingMonthStores from './TradingMonthStores.vue'

import { useQuery } from '@tanstack/vue-query'
import { todayOverview } from '@mp/api/mchTradeData/BpIndexDashboardController.js'

const tabActive = ref<'交易金额及笔数' | '活跃门店'>('交易金额及笔数')

const { data: overviewData } = useQuery({
  queryKey: ['statement/day/stat/trade/specifyDate/overview'],
  queryFn: () => todayOverview({}),
  select: data => data?.data,
})
</script>

<template>
  <section class="bg-white p-4 rounded-lg relative overflow-hidden" style="--el-border-color-light: transparent">
    <div class="flex justify-between">
      <label class="text-base text-n-800 flex font-medium">近30日交易趋势</label>
      <el-tabs v-model="tabActive" class=" -mt-[10px]" stretch style="--el-text-color-primary: var(--n-400)">
        <el-tab-pane name="交易金额及笔数">
          <template #label>
            <span id="TRADING_MONTH_AMOUNT_AND_COUNT_LABEL" v-track>交易金额及笔数</span>
          </template>
        </el-tab-pane>
        <el-tab-pane name="活跃门店">
          <template #label>
            <span id="TRADING_MONTH_ACTIVE_STORES_LABEL" v-track>活跃门店</span>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

    <p class="text-n-90 text-xs -mt-3">
      更新时间 {{ overviewData?.statTime }}
    </p>

    <TradingMonthAmount v-if="tabActive === '交易金额及笔数'" />
    <TradingMonthStores v-if="tabActive === '活跃门店'" />
  </section>
</template>

<style scoped>
:deep(.el-tabs__item) {
  padding: 0 10px;
}
</style>
